(() => {
  const wrap = (el) => el.closest('.shopify-section') || el;

  const panels = () => [...document.querySelectorAll('[data-haters-tab-panel]')];
  const tabs = () => [...document.querySelectorAll('[data-haters-tab]')];

  const show = (name) => {
    if (!name) return;

    tabs().forEach((tab) => {
      const on = tab.getAttribute('data-haters-tab') === name;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    panels().forEach((panel) => {
      const on = panel.getAttribute('data-haters-tab-panel') === name;
      const sectionEl = wrap(panel);

      panel.classList.toggle('is-active', on);
      panel.hidden = !on;
      panel.style.display = on ? '' : 'none';

      sectionEl.classList.toggle('haters-reward-tab-on', on);
      sectionEl.classList.toggle('haters-reward-tab-off', !on);
      sectionEl.classList.toggle('haters-reward-tab-hidden', !on);
      sectionEl.style.setProperty('display', on ? 'block' : 'none', 'important');
    });
  };

  const tabHidden = (tab) => !tab || tab.hidden || tab.classList.contains('is-hidden');

  const visibleTabs = () => tabs().filter((tab) => !tabHidden(tab));

  const firstTab = () => {
    const active = visibleTabs().find((tab) => tab.classList.contains('is-active'));
    return (active && active.getAttribute('data-haters-tab'))
      || (visibleTabs()[0] && visibleTabs()[0].getAttribute('data-haters-tab'))
      || 'access';
  };

  const syncMemberTab = () => {
    const active = document.querySelector('[data-haters-tab].is-active');
    if (tabHidden(active)) {
      const next = visibleTabs()[0];
      if (next) show(next.getAttribute('data-haters-tab'));
      return;
    }
    if (window.__hatersRewardTabPicked) return;
    const memberTab = document.querySelector('[data-haters-member-tab]');
    if (memberTab && !tabHidden(memberTab)) show(memberTab.getAttribute('data-haters-tab'));
  };

  const start = () => {
    if (!tabs().length || !panels().length) return false;
    show(firstTab());
    return true;
  };

  if (!window.__hatersRewardTabsBound) {
    window.__hatersRewardTabsBound = true;

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-haters-tab]');
      if (tab) {
        event.preventDefault();
        window.__hatersRewardTabPicked = true;
        show(tab.getAttribute('data-haters-tab'));
        return;
      }

      const opener = event.target.closest('[data-open-tab]');
      if (opener) {
        const href = opener.getAttribute('href') || '';
        if (!href || href === '#' || href.startsWith('#')) {
          event.preventDefault();
        }
        window.__hatersRewardTabPicked = true;
        show(opener.getAttribute('data-open-tab'));
      }
    });

    document.addEventListener('shopify:section:select', (event) => {
      const root = event.target;
      if (!root || !root.querySelector) return;
      const panel = root.querySelector('[data-haters-tab-panel]');
      if (panel) {
        window.__hatersRewardTabPicked = true;
        show(panel.getAttribute('data-haters-tab-panel'));
      }
    });

    document.addEventListener('shopify:section:load', () => {
      start();
    });

    document.addEventListener('loyalis:ready', syncMemberTab);
    document.addEventListener('loyalis:update', syncMemberTab);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else if (!start()) {
    let tries = 0;
    const wait = () => {
      tries += 1;
      if (!start() && tries < 40) requestAnimationFrame(wait);
    };
    wait();
  }
})();
